<template>
  <v-card class="back" style="height: 800px">
    <v-layout fill-height>
      <v-flex >
        <v-layout column fill-height>
          <scroll-area>
            <template slot="header">
              <v-toolbar dark color="secondary" dense flat>
                <v-toolbar-title>
                  <span v-if="addMode" class="body-2 text-uppercase">{{$t('create new connection')}}</span>
                  <span v-if="!addMode && getData.name" class="body-2 text-uppercase">{{ getData.name }}</span>
                </v-toolbar-title>

                <v-layout  justify-end>
                
                  <v-tooltip v-if="addMode && !readonly" dark color="secondary" bottom>
                    <v-btn :data-testid="$options.name + 'v-btn' + 'createData'" v-if="addMode" icon flat slot="activator" @click="() => createData()">
                      <svg-icon
                        :color="'white'"
                        :name="'done'"
                        width="20"
                      />
                    </v-btn>
                    <span>{{ $t('create') }}</span>
                  </v-tooltip>

                  <v-tooltip v-if="!addMode && !editMode && !readonly" dark color="secondary" bottom>
                    <v-btn :data-testid="$options.name + 'v-btn' + 'editMode--editMode'" v-if="!addMode && !editMode" icon flat slot="activator" @click="() => {editMode = !editMode}">
                      <svg-icon
                        :color="'white'"
                        :name="'edit'"
                        width="20"
                      />
                    </v-btn>
                    <span>{{ $t('edit') }}</span>
                  </v-tooltip>

                  <v-tooltip v-if="!addMode && editMode && !readonly" dark color="secondary" bottom>
                    <v-btn :data-testid="$options.name + 'v-btn' + 'removeItem'" v-if="!addMode && editMode" icon flat slot="activator" @click="() => removeItem()">
                      <svg-icon
                        :color="'white'"
                        :name="'basket'"
                        width="20"
                      />
                    </v-btn>
                    <span>{{ $t('remove') }}</span>
                  </v-tooltip>

                  <v-tooltip v-if="!addMode && editMode && !readonly" dark color="secondary" bottom>
                    <v-btn :data-testid="$options.name + 'v-btn' + 'saveData'" v-if="!addMode && editMode" icon flat slot="activator" @click="() => saveData()">
                      <svg-icon
                        :color="'white'"
                        :name="'done'"
                        width="20"
                      />
                    </v-btn>
                    <span>{{ $t('save') }}</span>
                  </v-tooltip>

                  <v-tooltip v-if="!addMode && editMode" dark color="secondary" bottom>
                    <v-btn :data-testid="$options.name + 'v-btn' + 'editMode--close'" icon v-if="!addMode && editMode" flat slot="activator" @click="() => {editMode = !editMode}">
                      <svg-icon
                        :color="'white'"
                        :name="'close'"
                        width="20"
                      />
                    </v-btn>
                    <span>{{ $t('cancel') }}</span>
                  </v-tooltip>

                  <v-tooltip v-if="!editMode" dark color="secondary" bottom>
                    <v-btn :data-testid="$options.name + 'v-btn' + 'emit-close'" icon v-if="!editMode" flat slot="activator" @click="()=>{$emit('close')}">
                      <svg-icon
                        :color="'white'"
                        :name="'close'"
                        width="20"
                      />
                    </v-btn>
                    <span>{{ $t('close') }}</span>
                  </v-tooltip>
                  
                </v-layout>

              </v-toolbar>             
            </template>

            <template slot="body">
              <v-layout column fill-height justify-start class="pa-2">
                <v-form ref="connection_card_form">

                  <v-layout  justify-start class="pb-2">

                    <v-flex xs6 shrink pa-0 >
                      <v-layout shrink v-for="(field, index) in getFields" :key="index" v-if="field.show == 'true' && field.type != 'timestamp'" >
                        <v-flex xs4 shrink v-if="field.type != 'boolean' && field.type != 'select' && field.type != 'select_enum'" pa-0 >
                          <v-text-field
                            :value="$t(field.name)"
                            light
                            auto-grow
                            
                            single-line
                            flat
                            readonly
                            disabled
                            class="white"
                            persistent-hint
                            hide-details
                            
                            :rows="1"
                            color="grey"
                          >
                          </v-text-field>
                        </v-flex>
                        
                        <v-flex xs8 shrink field.type != 'boolean' pa-0>

                          <v-tooltip v-if="getDescriptions[field]" dark color="secondary" bottom>

                            <v-text-field
                              v-if="field.type == 'integer'"
                              slot="activator"
                              v-model.number="model.obj[field.name]"
                              :data-testid="$options.name + '_v-text-field_' + field.name"
                              :type="'number'"
                              :readonly="!addMode && !editMode"
                              :disabled="!addMode && !editMode"
                              light
                              auto-grow
                              
                              single-line
                              flat
                              class="white"
                              persistent-hint
                              hide-details                     
                              :rows="1"
                              color="accent"
                            >
                            </v-text-field>

                            <v-text-field
                              v-else
                              slot="activator"
                              v-model="model.obj[field.name]"
                              :data-testid="$options.name + '_v-text-field_' + field.name"
                              light
                              :readonly="!addMode && !editMode"
                              :disabled="!addMode && !editMode"
                              auto-grow
                              
                              single-line
                              flat
                              class="white"
                              persistent-hint
                              hide-details                     
                              :rows="1"
                              color="accent"
                            >
                            </v-text-field>
                            <span >{{ $t(getDescriptions[field.name]) }}</span>
                          </v-tooltip>

                          <v-text-field
                            v-if="!getDescriptions[field.name] && field.type == 'integer'"
                            v-model.number="model.obj[field.name]"
                            :data-testid="$options.name + '_v-text-field_' + field.name"
                            :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                            :required="model.fields[field.name].required"
                            :type="'number'"
                            :readonly="!addMode && !editMode"
                            :disabled="!addMode && !editMode"
                            light
                            auto-grow
                            
                            single-line
                            flat
                            class="white"
                            persistent-hint
                            hide-details                     
                            :rows="1"
                            color="accent"
                          >
                          </v-text-field>
                          
                          <v-text-field
                            v-if="!getDescriptions[field.name] && field.type == 'text'"
                            v-model="model.obj[field.name]"
                            :data-testid="$options.name + '_v-text-field_' + field.name"
                            :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                            :required="model.fields[field.name].required"
                            light
                            :readonly="!addMode && !editMode"
                            :disabled="!addMode && !editMode"
                            auto-grow
                            
                            single-line
                            flat
                            class="white"
                            persistent-hint
                            hide-details                     
                            :rows="1"
                            color="accent"
                          >
                          </v-text-field>

                        </v-flex>

                      </v-layout>
                    </v-flex>

                    <v-flex xs6 shrink pl-2 >
                      <v-layout shrink v-for="(field, index) in getFields" :key="index" v-if="field.show == 'true' && field.type != 'timestamp'" >
                        <v-flex xs4 shrink v-if="field.type != 'boolean' && (field.type == 'select' || field.type == 'select_enum')" pa-0 >
                          <v-text-field
                            :value="$t(field.name)"
                            light
                            auto-grow
                            single-line
                            flat
                            readonly
                            disabled
                            class="white"
                            persistent-hint
                            hide-details
                            :rows="1"
                            color="grey"
                          >
                          </v-text-field>
                        </v-flex>
                        
                        <v-flex xs8 shrink field.type != 'boolean' pa-0>

                          <v-select
                            v-if="(field.type == 'select' || field.type == 'select_enum') && field.name != 'template'"
                            v-model="model.obj[field.name]"
                            :data-testid="$options.name + '_v-select_' + field.name"
                            light
                            :readonly="!addMode && !editMode"
                            :disabled="!addMode && !editMode"
                            :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                            required
                            :items="getItems[field.cls]"
                            :item-text="field.type == 'select' ? 'name' : 'value'"
                            :item-value="field.type == 'select' ? '$id' : 'id'"
                            single-line
                            
                            hide-details
                            flat
                            class="white"
                            background-color="white"
                            
                          >
                            <template v-slot:item="{ item, index }">
                                <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                            </template>
                          </v-select>

                          <v-select
                            v-if="(field.type == 'select' || field.type == 'select_enum') && field.name == 'template'"
                            v-model="model.obj[field.name]"
                            :data-testid="$options.name + '_v-select_' + field.name"
                            light
                            :readonly="!addMode && !editMode"
                            :disabled="!addMode && !editMode"
                            :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                            required
                            :items="getItems[field.cls]"
                            item-text="id"
                            item-value="id"
                            single-line
                            
                            hide-details
                            flat
                            class="white"
                            background-color="white"
                            
                          >
                            <template v-slot:item="{ item, index }">
                                <span>{{ $t(item.id) }}</span>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <span>{{ $t(item.id) }}</span>
                            </template>
                          </v-select>

                        </v-flex>

                      </v-layout>
                    </v-flex>

                  </v-layout>

                  <v-layout row v-if="getFields" justify-space-between align-center class="white" >
                    <v-flex xs12 v-for="(field, index) in getFields" :key="index" v-if="field.show == 'true' && field.type == 'timestamp'">
                      <date-picker
                        :value="model.obj[field.name]"
                        :label="field.name"
                        :readonly="!addMode && !editMode"
                        :disabled="!addMode && !editMode"
                        @dateChange="(payload) => {onDateChange(payload, field.name)}"
                      />

                    </v-flex>
                  </v-layout>

                  <v-layout row v-if="getFields" justify-space-between align-center class="white" >
                    <v-flex xs12 v-for="(field, index) in getFields" :key="index" v-if="field.show == 'true' && field.type == 'boolean'">
                      <v-checkbox
                        small
                        light
                        color="secondary"
                        v-if="field.type == 'boolean'"
                        v-model="model.obj[field.name]"
                        :data-testid="$options.name + '_v-checkbox_' + field.name"
                        :readonly="!addMode && !editMode"
                        :disabled="!addMode && !editMode"
                      >
                        <template v-slot:label>
                          <span class="black--text" v-if="model.fields[field.name] && model.fields[field.name].required">{{$t(field.name) + ' *'}}</span>
                          <span class="black--text" v-else>{{$t(field.name)}}</span>
                        </template>
                      </v-checkbox>
                    </v-flex>
                  </v-layout>

                  <v-layout column v-if="getFields && !addMode">
                        <v-layout grow align-center justify-space-around class="secondary" pa-2>
                          <span class="body-2 text-uppercase white--text">{{$t('side 1')}}</span>
                          <span class="body-2 text-uppercase white--text">{{$t('endpoints')}}</span>
                          <span class="body-2 text-uppercase white--text">{{$t('side 2')}}</span>                       
                        </v-layout>

                    <v-layout>
                      <v-flex xs6 pa-2>
                        {{ getData.point_a[0].path }}
                      </v-flex>
                      <v-flex xs6 pa-2>
                        {{ getData.point_b[0].path }}
                      </v-flex>
                    </v-layout>
                  </v-layout>

                  <v-layout column v-if="model.obj.template && addMode"  style="height: 68%">

                    <v-layout grow align-center justify-space-around class="secondary" pa-2>
                      <span class="body-2 text-uppercase white--text">{{$t('side 1')}}</span>
                      <span class="body-2 text-uppercase white--text">{{$t('endpoints')}}</span>
                      <span class="body-2 text-uppercase white--text">{{$t('side 2')}}</span>                       
                    </v-layout>

                    <v-layout v-if="getFields" fill-height>

                          <v-flex xs6 >

                            <v-layout column fill-height>

                              <v-flex v-if="model.refs.endpoint && model.refs.endpoint[0]" py-1>

                                <v-card class="back" height="80px" flat>

                                  <v-card-text primary-title>
                                      <v-layout column class="back">

                                        <v-layout justify-start align-center py-1>
                                          <span>{{getPathString(model.refs.endpoint[0].namePath)}}</span>

                                        </v-layout>

                                      </v-layout>

                                  </v-card-text>

                                </v-card>

                              </v-flex>

                              <scroll-area>

                                <template slot="body">

                                  <v-layout column fill-height>

                                    <logical-tree
                                      v-if="model.obj.template && showTree"
                                      :open="true"
                                      :portType="model.obj.port_type"
                                      :template="model.obj.template"
                                      :templates="model.items.template"
                                      @select="(payload) => onEndpointSelect(payload, 'start')"
                                    />

                                  </v-layout>

                                </template>

                              </scroll-area>

                            </v-layout>

                          </v-flex>

                          <v-divider vertical></v-divider>

                          <v-flex xs6>

                            <v-layout column fill-height>

                              <v-flex v-if="model.refs.endpoint && model.refs.endpoint[1]" py-1 >

                                <v-card class="back" height="80px" flat>

                                  <v-card-text primary-title>

                                    <v-layout column class="back">

                                      <v-layout justify-center align-center py-1>
                                        <span>{{getPathString(model.refs.endpoint[1].namePath)}}</span>
                                      </v-layout>

                                    </v-layout>

                                  </v-card-text>

                                </v-card>

                              </v-flex>

                              <scroll-area v-if="showTree">

                                <template slot="body">

                                  <v-layout column fill-height>

                                    <logical-tree
                                      v-if="model.obj.template && showTree"
                                      :open="true"
                                      :portType="model.obj.port_type"
                                      :template="model.obj.template"
                                      :templates="model.items.template"
                                      @select="(payload) => onEndpointSelect(payload, 'end')"
                                    />

                                  </v-layout>

                                </template>

                              </scroll-area>

                            </v-layout>

                          </v-flex>

                    </v-layout>

                  </v-layout>

                </v-form>
              </v-layout>
            </template>

          </scroll-area>
        </v-layout>

        
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script lang="ts">
import Vue from 'vue'
import loadingCircle from '@/nms/components/partials/loader.vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import crumbs from '@/nms/components/partials/bread-crumbs.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import datePicker from '@/nms/components/controls/input-menu-datepicker.vue'
import LogicalTree from '@/nms/pages/services/logical-tree.vue'
import { CCMDBObject } from '@entcor/ebridge'

// Типы
interface EndpointRef {
  $ref_id?: string
  ref: string
  type: string
  $id?: string
  [key: string]: any
}

interface ModelData {
  fields: Record<string, any>
  obj: Record<string, any>
  items: Record<string, any>
  refs: {
    endpoint?: EndpointRef[]
    [key: string]: any
  }
}

interface MetaData {
  [key: string]: any
}

interface ConnectionData {
  $id?: string
  id?: string
  name?: string
  cls?: string
  [key: string]: any
}

interface ParentData {
  [key: string]: any
}

interface DescriptorData {
  [key: string]: any
}

interface DescriptionsData {
  [key: string]: any
}

interface BridgeObject {
  $id?: string
  $ref_id?: string
  _cmdb_?: boolean
  cls?: string
  name?: string
  getParents?: (options?: any) => Promise<any[]>
  [key: string]: any
}

export default Vue.extend({
  name: 'CONNECTION_CARD',

  components: {
    loadingCircle,
    scrollTable,
    scrollArea,
    crumbs,
    svgIcon,
    datePicker,
    LogicalTree
  },

  props: {
    data: {
      type: Object as () => ConnectionData,
      default: () => ({})
    },
    parentData: {
      type: Object as () => ParentData,
      default: () => ({})
    },
    descriptor: {
      type: Object as () => DescriptorData,
      default: () => ({})
    },
    addMode: {
      type: Boolean,
      default: () => false
    },
    descriptions: {
      type: Object as () => DescriptionsData,
      default: () => ({})
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
  },

  data(): {
    editMode: boolean
    meta: MetaData | null
    model: ModelData
    dataObj: any | null
    showTree: boolean
    getEdited?: ConnectionData
  } {
    return {
      editMode: false,
      meta: null,
      model: {
        fields: {},
        obj: {},
        items: {},
        refs: {},
      },
      dataObj: null,
      showTree: false,
    }
  },

  watch: {
    'model.obj.template': {
      handler(newVal: string, oldVal: string): void {
        console.log('WATCH', 'CONNECTION_CARD', 'TEMPLATE oldVal', oldVal)
        console.log('WATCH', 'CONNECTION_CARD', 'TEMPLATE newVal', newVal)
        if (newVal === oldVal) return
        this.$set(this.model.refs, 'endpoint', [])
      },
      deep: true
    },
  },

  computed: {
    getData(): ConnectionData {
      return this.data
    },
    getFields(): Record<string, any> {
      return this.model.fields
    },
    getItems(): Record<string, any> {
      return this.model.items
    },
    getDescriptions(): DescriptionsData {
      return this.descriptions
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    async setup(): Promise<void> {
      this.$set(this.model, 'fields', {})
      this.$set(this.model, 'items', {})
      this.$set(this.model, 'obj', {})
      this.$set(this.model, 'refs', {})

      await this.loadMeta()
      this.showTree = true
    },

    async loadMeta(caller?: string): Promise<void> {
      try {
        this.setLoader('loadMeta', true)
        this.dataObj = await this.$bridge.getByPath('/logical/connection')
        this.meta = await this.$bridge.getMeta(this.dataObj.s$children[0])
        
        if (this.meta) {
          this.model = await this.$prepareMeta(this.meta, this.$options.name)
          const $_templates = await this.$bridge.getTemplates(this.dataObj.s$children[0])
          this.$set(this.model.items, 'template', $_templates)
          if (!this.addMode) {
            this.prepareData()
          }
        }
        this.setLoader('loadMeta', false)
      } catch (error) {
        this.setLoader('loadMeta', false)
        console.error('loadMeta error', error)
      }
    },

    async prepareData(): Promise<void> {
      try {
        const model = await this.$prepareData(this.model, this.getData, this.meta, this.$options.name)
        console.log(this.$options.name, 'prepareData', 'model', model)
        this.model = model
      } catch (error) {
        this.setLoader('loadMeta', false)
        console.error('prepareData error', error)
      }
    },

    async onEndpointSelect(val: BridgeObject, point: string): Promise<void> {
      console.log('CONNECTION_CARD', 'ENDPOINTS', 'val', val, 'point', point)
      
      const payload = val._cmdb_ ? val : await this.$bridge.getObjectById(val.$id)
      const index = point === 'start' ? 0 : 1

      try {
        if (!this.model.refs.endpoint) {
          this.$set(this.model.refs, 'endpoint', [])
        }
        
        if (this.model.refs.endpoint.length) {
          const duplicate = this.model.refs.endpoint.some(endpoint$ => endpoint$.$id === payload.$id)
          console.log('CONNECTION_CARD', 'ENDPOINTS', 'duplicate', duplicate, 'payload', payload)
          
          if (duplicate) {
            this.$dialog.notify.error(this.$getTranslate('port is already selected'), {
              timeout: 2000
            })
            return
          }
        }

        if (point && payload.getParents) {
          const parents = await payload.getParents()
          if (parents?.length) {
            const p$ = parents.filter(parent => {
              return parent.cls === 'device' || parent.cls === 'slot' || 
                     parent.cls === 'module' || parent.cls === 'submodule' || parent.cls === 'port'
            })
            payload.parent = p$
            
            const l$ = parents.filter(parent => {
              return parent.cls === 'location' || parent.cls === 'cabinet'
            })
            payload.location = l$
            
            this.$set(this.model.refs.endpoint, index, { ...this.model.refs.endpoint[index], ...payload })
          }
        }
      } catch (error) {
        console.error('CONNECTION_CARD', 'onEndpointSelect', 'error', error)
      }
    },

    getPathString(path: any[] | undefined): string {
      if (!path?.length) return ''
      let str = ''
      path.forEach((item, i) => {
        if (i === path.length - 1) {
          str = str + ' ' + item
        } else {
          str = str + ' ' + item + ' /'
        }
      })
      return str
    },

    onDateChange(payload: any, fieldName: string): void {
      this.$set(this.model.obj, fieldName, payload)
    },

    removeItem(): void {
      this.$dialog.confirm({
        text: `Удалить ${this.getData.name}?`,
        title: 'Удаление',
        actions: {
          false: 'Отмена',
          true: {
            color: 'red',
            text: 'Удалить',
            handle: () => {
              this.$emit('remove', this.getData)
            }
          }
        }
      })
    },

    async saveData(): Promise<void> {
      console.log('this.model.obj', this.model.obj)
      try {
        this.$dialog.confirm({
          text: 'Сохранить изменения?',
          title: 'Сохранение',
          actions: {
            false: 'Отмена',
            true: {
              color: 'green',
              text: 'Сохранить',
              handle: () => {
                this.$emit('update', this.model.obj)
                this.$emit('close')
              }
            }
          }
        })
      } catch (err) {
        this.$errorHandler(err)
      }
    },

    async createData(): Promise<void> {
      const formRef = this.$refs['connection_card_form'] as any
      const v = formRef?.validate() ?? false
      
      if (!v) return

      const data$: Record<string, any> = {}
      const fields = Object.keys(this.model.obj)
      fields.forEach(field => {
        data$[field] = this.model.obj[field]
      })

      const refs$: EndpointRef[] = []

      if (this.model.refs.endpoint) {
        if (this.model.refs.endpoint.length < 2) {
          this.$dialog.notify.error(this.$getTranslate('two endpoints must be selected'), {
            timeout: 2000
          })
          return
        }
        this.model.refs.endpoint.forEach(point => {
          const ref$: EndpointRef = {
            $ref_id: point.$ref_id,
            ref: 'endpoint',
            type: 'stateRef',
            $id: point.$id
          }
          refs$.push(ref$)
        })
      }
      data$.refs = refs$

      try {
        const edited = (this as any).getEdited as ConnectionData | undefined
        
        if (edited?.$id) {
          const $obj = await this.$bridge.getObjectById(edited.$id)
          const c = await $obj.update(data$)
          if (c) {
            this.$dialog.notify.success('Соединение успешно изменено!', { timeout: 5000 })
            await this.$store.dispatch('updateObject', { $id: c.$id })
            this.$bridge.litePolling(c.$id)
            this.$emit('update')
            this.$emit('close')
          } else {
            this.$dialog.notify.error(this.$getTranslate('something wrong with connection'), { timeout: 5000 })
          }
        } else {
          const $obj = await this.$bridge.getObjectById(this.dataObj.$id)
          console.log('CONNECTION_CARD', 'createData', '$obj', $obj)
          console.log('CONNECTION_CARD', 'createData', 'data$', data$)
          const c = await $obj.createChild($obj.s$children[0], data$)
          if (c) {
            this.$dialog.notify.success('Соединение успешно создано!', { timeout: 5000 })
            await this.$store.dispatch('updateObject', { $id: c.$id })
            this.$bridge.litePolling(c.$id)
            this.$emit('update')
            this.$emit('close')
          } else {
            this.$dialog.notify.error(this.$getTranslate('something wrong with connection'), { timeout: 5000 })
          }
        }
      } catch (err) {
        this.$errorHandler(err)
      }
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },
  },
})
</script>

<style lang="stylus" scoped>
.rule
  border 1px solid #c1c163
  margin-bottom: 5px;
  padding: 5px;
.rule-item
  //border 1px solid red
  display flex
  justify-content stretch
  align-items baseline
  .field
    margin 0 3px
    outline: darkgray solid 1px;
    height: 30px;
    padding-left: 5px;
    line-height: 30px;
    background-color: white;
.v-btn.supersmall
  padding-top: 4px
  height: 24px
  width: 24px
  right: 5px
</style>
